<template>
  <div
    v-if="show"
    class="fixed z-10 inset-0 bg-gray-900 bg-opacity-60 overflow-y-scroll h-full w-full flex items-center justify-center text-base"
  >
    <div class="bg-white rounded-lg shadow-xl w-10/12 max-w-2xl">
      <div class="flex items-center justify-between p-4 border-b">
        <h4 class="text-2xl text-gray-800 font-bold">Edit Stock Batch</h4>
        <button type="button" class="ml-auto p-1.5 inline-flex text-gray-500 h-8 w-8 hover:text-custom-yellow" @click="$emit('close')">
          <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>
      </div>

      <form @submit.prevent="submitForm" class="space-y-4 py-6">
        <div class="grid grid-cols-2 gap-x-20 gap-y-6 px-20">
          <div>
            <label class="block text-sm font-medium text-gray-700">Batch No<span class="text-red-500">*</span></label>
            <input type="text" v-model="form.batch_no"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50" />
            <span class="text-sm text-red-500" v-if="errors.batch_no">Batch number is required</span>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Expiry Date<span class="text-red-500">*</span></label>
            <input type="date" v-model="form.expiry_date"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50" />
            <span class="text-sm text-red-500" v-if="errors.expiry_date">Expiry date is required</span>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Quantity<span class="text-red-500">*</span></label>
            <input type="number" step="0.01" v-model="form.actual_quantity"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50" />
            <span class="text-sm text-red-500" v-if="errors.actual_quantity">Quantity is required</span>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Cost Price<span class="text-red-500">*</span></label>
            <input type="number" step="0.01" v-model="form.cost_price"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50" />
            <span class="text-sm text-red-500" v-if="errors.cost_price">Cost price is required</span>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Selling Price<span class="text-red-500">*</span></label>
            <input type="number" step="0.01" v-model="form.selling_price"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50" />
            <span class="text-sm text-red-500" v-if="errors.selling_price">Selling price is required</span>
          </div>
        </div>

        <div class="flex justify-end px-20">
          <button type="submit" :disabled="showLoader"
            class="px-4 py-2 bg-custom-yellow text-white rounded-md hover:bg-yellow-500">
            <span v-if="!showLoader">Save Changes</span>
            <span v-else>
              <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"/>
              </svg>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/api";

export default {
  name: "EditInventoryStockModal",
  props: {
    show: { type: Boolean, required: true },
    stockItem: { type: Object, required: true },
  },
  emits: ["close", "updated"],
  data() {
    return {
      form: {
        batch_no: "",
        expiry_date: "",
        actual_quantity: "",
        cost_price: "",
        selling_price: "",
      },
      errors: {},
      showLoader: false,
    };
  },
  watch: {
    stockItem: {
      immediate: true,
      handler(item) {
        if (item && item.id) {
          this.form = {
            batch_no: item.batch_no,
            expiry_date: item.expiry_date,
            actual_quantity: item.actual_quantity,
            cost_price: item.cost_price,
            selling_price: item.selling_price,
          };
        }
      },
    },
  },
  methods: {
    async submitForm() {
      if (!this.validateForm()) return;
      try {
        this.showLoader = true;
        const response = await apiClient.updateInventoryStockItem(this.stockItem.id, this.form);
        if (response.success) {
          this.$toast.success("Stock batch updated successfully");
          this.$emit("updated"); // tell parent to refresh
          this.$emit("close");
        } else {
          this.$toast.error(response.message || "Failed to update stock batch");
        }
      } catch (error) {
        this.$toast.error("Failed to update stock batch");
        console.log(error);
      } finally {
        this.showLoader = false;
      }
    },
    validateForm() {
      this.errors = {};
      ["batch_no", "expiry_date", "actual_quantity", "cost_price", "selling_price"].forEach((f) => {
        if (!this.form[f] && this.form[f] !== 0) this.errors[f] = true;
      });
      return Object.keys(this.errors).length === 0;
    },
  },
};
</script>